import { render } from "./ListProdukView.vue?vue&type=template&id=2acf2cfe"
import script from "./ListProdukView.vue?vue&type=script&lang=js"
export * from "./ListProdukView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__